/* Auto-built from nemiToken.json — every function of the contract is covered. */
import { fmt } from "../shared/format";

export const readFunctions = [
  {
    name: "DOMAIN_SEPARATOR",
    title: "DOMAIN_SEPARATOR",
    description: "Read `DOMAIN_SEPARATOR` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "LIQUIDITY_CONTRACT_ALLOCATION",
    title: "LIQUIDITY_CONTRACT_ALLOCATION",
    description: "Read `LIQUIDITY_CONTRACT_ALLOCATION` from the contract",
    icon: "🔁",
    category: "Other",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "MAX_BURN_AMOUNT",
    title: "MAX_BURN_AMOUNT",
    description: "Read `MAX_BURN_AMOUNT` from the contract",
    icon: "🔥",
    category: "Other",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "TRADE_CONTRACT_ALLOCATION",
    title: "TRADE_CONTRACT_ALLOCATION",
    description: "Read `TRADE_CONTRACT_ALLOCATION` from the contract",
    icon: "🛒",
    category: "Other",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "_firstBuytime",
    title: "First Buytime",
    description: "Read `_firstBuytime` from the contract",
    icon: "⏱️",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "_firstReceivetime",
    title: "First Receivetime",
    description: "Read `_firstReceivetime` from the contract",
    icon: "⏱️",
    category: "Timing",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "_firstSelltime",
    title: "First Selltime",
    description: "Read `_firstSelltime` from the contract",
    icon: "⏱️",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "_firstTransfer",
    title: "First Transfer",
    description: "Read `_firstTransfer` from the contract",
    icon: "📤",
    category: "Limits & Flags",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "_isExcluded",
    title: "Is Excluded",
    description: "Read `_isExcluded` from the contract",
    icon: "🚫",
    category: "Limits & Flags",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "_totTransfers",
    title: "Tot Transfers",
    description: "Read `_totTransfers` from the contract",
    icon: "📤",
    category: "Limits & Flags",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "_totalAmountBuy",
    title: "Total Amount Buy",
    description: "Read `_totalAmountBuy` from the contract",
    icon: "💲",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "_totalAmountSell",
    title: "Total Amount Sell",
    description: "Read `_totalAmountSell` from the contract",
    icon: "💲",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "_totalAmountreceive",
    title: "Total Amountreceive",
    description: "Read `_totalAmountreceive` from the contract",
    icon: "💲",
    category: "Economics",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "allowance",
    title: "Allowance",
    description: "Read `allowance` from the contract",
    icon: "🪙",
    category: "Token",
    inputs: [
      { name: "owner", type: "address", label: "Owner", placeholder: "0x…", required: true },
      { name: "spender", type: "address", label: "Spender", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "balanceOf",
    title: "Balance Of",
    description: "Read `balanceOf` from the contract",
    icon: "🪙",
    category: "Token",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "blacklist",
    title: "Blacklist",
    description: "Read `blacklist` from the contract",
    icon: "🚫",
    category: "Limits & Flags",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "buying",
    title: "Buying",
    description: "Read `buying` from the contract",
    icon: "🛒",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "decimals",
    title: "Decimals",
    description: "Read `decimals` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "eip712Domain",
    title: "EIP712 Domain",
    description: "Read `eip712Domain` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => [
      `Fields: ${v.fields ?? v[0]}`,
      `Name: ${v.name ?? v[1]}`,
      `Version: ${v.version ?? v[2]}`,
      `Chain ID: ${v.chainId ?? v[3]}`,
      `Verifying Contract: ${v.verifyingContract ?? v[4]}`,
      `Salt: ${v.salt ?? v[5]}`,
      `Extensions: ${v.extensions ?? v[6]}`,
    ].join("\n"),
  },
  {
    name: "locktime",
    title: "Locktime",
    description: "Read `locktime` from the contract",
    icon: "⏱️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "lpReward",
    title: "LP Reward",
    description: "Read `lpReward` from the contract",
    icon: "💰",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "maxBuyAmount",
    title: "Max Buy Amount",
    description: "Read `maxBuyAmount` from the contract",
    icon: "💲",
    category: "Trading",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "maxMultisendPday",
    title: "Max Multisend Per Day",
    description: "Read `maxMultisendPday` from the contract",
    icon: "📈",
    category: "Economics",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "maxTrPerDay",
    title: "Max Transfer Per Day",
    description: "Read `maxTrPerDay` from the contract",
    icon: "📈",
    category: "Economics",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "maxsSellingAmount",
    title: "Maxs Selling Amount",
    description: "Read `maxsSellingAmount` from the contract",
    icon: "💲",
    category: "Trading",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "multisendaccount",
    title: "Multisendaccount",
    description: "Read `multisendaccount` from the contract",
    icon: "👤",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "name",
    title: "Name",
    description: "Read `name` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "nemiMarketplace",
    title: "NEMI Marketplace",
    description: "Read `nemiMarketplace` from the contract",
    icon: "🪙",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nonces",
    title: "Nonces",
    description: "Read `nonces` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [
      { name: "owner", type: "address", label: "Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "owner",
    title: "Owner",
    description: "Read `owner` from the contract",
    icon: "👑",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "pancakePair",
    title: "Pancake Pair",
    description: "Read `pancakePair` from the contract",
    icon: "🔁",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "paused",
    title: "Paused",
    description: "Read `paused` from the contract",
    icon: "⏸️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "selling",
    title: "Selling",
    description: "Read `selling` from the contract",
    icon: "💱",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "stakingContract",
    title: "Staking Contract",
    description: "Read `stakingContract` from the contract",
    icon: "🔒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "symbol",
    title: "Symbol",
    description: "Read `symbol` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "totalBurned",
    title: "Total Burned",
    description: "Read `totalBurned` from the contract",
    icon: "🔥",
    category: "Token",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "totalSupply",
    title: "Total Supply",
    description: "Read `totalSupply` from the contract",
    icon: "🪙",
    category: "Economics",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
];

export const writeFunctions = [
  {
    name: "Buy",
    title: "Buy NEMI with BNB",
    description: "Send BNB to the token contract and receive NEMI.",
    icon: "🛒",
    category: "User Actions",
    payableValue: { label: "BNB amount", placeholder: "e.g. 0.05" },
    inputs: [],
  },
  {
    name: "Sell",
    title: "Sell NEMI",
    description: "Sell NEMI back to the token contract.",
    icon: "💱",
    category: "User Actions",
    inputs: [
      { name: "_token", type: "uint256", label: "Token", placeholder: "Enter token", required: true },
    ],
  },
  {
    name: "approve",
    title: "Approve",
    description: "Allow a spender to move your NEMI.",
    icon: "🪙",
    category: "User Actions",
    inputs: [
      { name: "spender", type: "address", label: "Spender", placeholder: "0x…", required: true },
      { name: "value", type: "uint256", label: "Value", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "burn",
    title: "Burn",
    description: "Permanently destroy NEMI from your own balance.",
    icon: "🔥",
    category: "User Actions",
    inputs: [
      { name: "value", type: "uint256", label: "Value", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "burnFrom",
    title: "Burn From",
    description: "Burn NEMI from another address (needs allowance).",
    icon: "🔥",
    category: "User Actions",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "value", type: "uint256", label: "Value", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "getTokens",
    title: "Get Tokens",
    description: "Withdraw purchased tokens after the lock time.",
    icon: "🪙",
    category: "User Actions",
    inputs: [
      { name: "_amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "permit",
    title: "Permit (Gasless Approve)",
    description: "Approve via an EIP-2612 signature.",
    icon: "🪙",
    category: "User Actions",
    inputs: [
      { name: "owner", type: "address", label: "Owner", placeholder: "0x…", required: true },
      { name: "spender", type: "address", label: "Spender", placeholder: "0x…", required: true },
      { name: "value", type: "uint256", label: "Value", placeholder: "e.g. 10.5", required: true, unit: "ether" },
      { name: "deadline", type: "uint256", label: "Deadline", placeholder: "Enter deadline", required: true },
      { name: "v", type: "uint8", label: "V", placeholder: "Enter v", required: true },
      { name: "r", type: "bytes32", label: "R", placeholder: "0x…", required: false },
      { name: "s", type: "bytes32", label: "S", placeholder: "0x…", required: false },
    ],
  },
  {
    name: "transfer",
    title: "Transfer",
    description: "Send NEMI to another address.",
    icon: "📤",
    category: "User Actions",
    inputs: [
      { name: "to", type: "address", label: "To", placeholder: "0x…", required: true },
      { name: "value", type: "uint256", label: "Value", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "transferFrom",
    title: "Transfer From",
    description: "Move NEMI on behalf of another address (needs allowance).",
    icon: "📤",
    category: "User Actions",
    inputs: [
      { name: "from", type: "address", label: "From", placeholder: "0x…", required: true },
      { name: "to", type: "address", label: "To", placeholder: "0x…", required: true },
      { name: "value", type: "uint256", label: "Value", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
];

export const adminFunctions = [
  {
    name: "ExcludefromLimits",
    title: "Excludefrom Limits",
    description: "Call `ExcludefromLimits` on the contract",
    icon: "🚫",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "_addr", type: "address", label: "Addr", placeholder: "0x…", required: true },
      { name: "_state", type: "bool", label: "State", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "WithDrawBNB",
    title: "With Draw BNB",
    description: "Call `WithDrawBNB` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "_amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "addPairAddress",
    title: "Add Pair Address",
    description: "Call `addPairAddress` on the contract",
    icon: "🔁",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "_pair", type: "address", label: "Pair", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "addToblackList",
    title: "Add Toblack List",
    description: "Call `addToblackList` on the contract",
    icon: "🚫",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "_addr", type: "address", label: "Addr", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "initialize",
    title: "Initialize",
    description: "Call `initialize` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "initialOwner", type: "address", label: "Initial Owner", placeholder: "0x…", required: true },
      { name: "_tradeContract", type: "address", label: "Trade Contract", placeholder: "0x…", required: true },
      { name: "_liquidityContract", type: "address", label: "Liquidity Contract", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "mint",
    title: "Mint",
    description: "Call `mint` on the contract",
    icon: "🪙",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "to", type: "address", label: "To", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "multiSendToken",
    title: "Multi Send Token",
    description: "Call `multiSendToken` on the contract",
    icon: "🪙",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "_contributors", type: "address[]", label: "Contributors", placeholder: "value1, value2, …", required: true, isArray: true },
      { name: "__balances", type: "uint256[]", label: "Balances", placeholder: "e.g. 10.5, 25", required: true, isArray: true, unit: "ether" },
    ],
  },
  {
    name: "newSetup",
    title: "New Setup",
    description: "Call `newSetup` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "pause",
    title: "Pause",
    description: "Call `pause` on the contract",
    icon: "⏸️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "removeFromBlackList",
    title: "Remove From Black List",
    description: "Call `removeFromBlackList` on the contract",
    icon: "🚫",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "_addr", type: "address", label: "Addr", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "renounceOwnership",
    title: "Renounce Ownership",
    description: "Call `renounceOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setBuyLimit",
    title: "Set Buy Limit",
    description: "Call `setBuyLimit` on the contract",
    icon: "⚙️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "_amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setLpRewardContract",
    title: "Set LP Reward Contract",
    description: "Call `setLpRewardContract` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newLpReward", type: "address", label: "New LP Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setMaxMultiSendPday",
    title: "Set Max Multi Send Pday",
    description: "Call `setMaxMultiSendPday` on the contract",
    icon: "📈",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "_amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setMaxSell",
    title: "Set Max Sell",
    description: "Call `setMaxSell` on the contract",
    icon: "📈",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "_amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setMultiSendAccount",
    title: "Set Multi Send Account",
    description: "Call `setMultiSendAccount` on the contract",
    icon: "👤",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "_addr", type: "address", label: "Addr", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNemiMarketplaceContract",
    title: "Set NEMI Marketplace Contract",
    description: "Call `setNemiMarketplaceContract` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNemiMarketplace", type: "address", label: "New NEMI Marketplace", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setPerDayTransferLimit",
    title: "Set Per Day Transfer Limit",
    description: "Call `setPerDayTransferLimit` on the contract",
    icon: "📤",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "_amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setStakingContract",
    title: "Set Staking Contract",
    description: "Call `setStakingContract` on the contract",
    icon: "🔒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newStakingContract", type: "address", label: "New Staking Contract", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "transferOwnership",
    title: "Transfer Ownership",
    description: "Call `transferOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "newOwner", type: "address", label: "New Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "unpause",
    title: "Unpause",
    description: "Call `unpause` on the contract",
    icon: "▶️",
    category: "Admin Control",
    ownerOnly: true,
    allowWhilePaused: true,
    inputs: [],
  },
];

const tokenFunctions = { readFunctions, writeFunctions, adminFunctions };
export default tokenFunctions;
